import * as React from 'react';
import Flex from '../../../components/Flex';
import FormField from '../../../components/FormField';
import TextField from '../../../components/TextField';
import {PillButton} from '../../../components/Button';
import {IconCheckCircle} from '../../../components/SvgIcon';
import {FormikProps} from 'formik';

export interface FormValues {
  email: string;
}

interface ForgotPasswordFormBaseProps extends FormikProps<FormValues> {
  loading: boolean;
}

// TODO: Add error message display capability to TextField component.
const ErrorMessage = ({children, show}: {children: React.ReactNode; show: boolean}) => {
  if (show) {
    return <div style={{fontFamily: 'Roboto', color: '#C00', padding: '8px 0'}}>{children}</div>;
  }
  return null;
};

export default class ForgotPasswordFormBase extends React.Component<ForgotPasswordFormBaseProps, {}> {
  public render() {
    const {values, errors, touched, handleChange, handleBlur, handleSubmit, loading} = this.props;

    // TODO: add success state to TextField component
    const checkCircle = <IconCheckCircle color="#08C173" />;

    return (
      <form onSubmit={handleSubmit}>
        <FormField label="Email">
          <TextField
            type="email"
            id="email"
            value={values.email}
            icon={!errors.email && touched.email && checkCircle}
            onChange={handleChange}
            onBlur={handleBlur}
            large={true}
            iconPosition="end"
          />
          <ErrorMessage show={Boolean(errors.email && touched.email)}>{errors.email}</ErrorMessage>
        </FormField>
        <Flex center={true}>
          <PillButton type="submit" variant="primary" loading={loading} large={true} style={{marginBottom: 100}}>
            Submit
          </PillButton>
        </Flex>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordForm/private/BaseForm.tsx